module.exports = __webpack_public_path__ + "img/Slide8.5d2dee13.png";